import { useSyncExternalStore } from 'react';

let activeTaskId: string | null = null;

const listeners = new Set<() => void>();

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const setActiveOnboardingFormTourTaskId = (taskId: string | null) => {
  if (activeTaskId === taskId) {
    return;
  }

  activeTaskId = taskId;
  notifyListeners();
};

export const clearActiveOnboardingFormTourTaskId = () => {
  setActiveOnboardingFormTourTaskId(null);
};

export const getActiveOnboardingFormTourTaskId = () => activeTaskId;

export const isOnboardingFormTourActive = (taskId?: string) => {
  if (!activeTaskId) {
    return false;
  }

  if (taskId) {
    return activeTaskId === taskId;
  }

  return true;
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => activeTaskId;

export const useOnboardingFormTourTaskId = () => useSyncExternalStore(subscribe, getSnapshot, () => null);

export const useIsOnboardingFormTourActive = (taskId?: string) => {
  const currentTaskId = useOnboardingFormTourTaskId();

  if (!currentTaskId) {
    return false;
  }

  if (taskId) {
    return currentTaskId === taskId;
  }

  return true;
};
